
export class RegistryLookupError extends Error {
    constructor(public registry: string, public key: string) {
        super(`No "${key}" in ${registry} registry`)
    }
}

export interface IResolver {
    resolve(url: URL, cancel?: AbortSignal): Promise<any>;
}